import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { UserProvider } from './context/UserContext';


import Dashboard from './components/dashboard/Dashboard';
import Login from './components/login/Login';
import ResetPassword from './components/login/ResetPassword';
import ImageResults from './components/Results/resultsScreen/ImageResults.jsx';
import ProyectsScreen from './components/proyects/ProyectsScreen';
import DashboardHome from './components/dashboard/DashboardHome';
import ThermalDashboard from './components/dashboard/ThermalDashboard';
import {
  ModulePlaceholder,
  ModuleSelection,
  modulePlaceholderIcons,
} from './components/modules/ModuleSelection';
import { ReportsScreen } from './components/reports/ReportsScreen.tsx';
import NewProject from './components/proyects/NewProject/NewProject';
import ProjectDetails from './components/projectDetails/ProjectDetails';
import InspectionDetails from './components/inspectionDetails/InspectionDetails';
import SelectImages from './components/imageSelection/SelectImages';
import UploadImagesScreen from './components/UploadImages/UploadImagesScreen';
import ProfileScreen from './components/profile/ProfileScreen';
import UsersScreen from './components/users/UsersScreen';
import NotificationsScreen from './components/notifications/NotificationsScreen';
import HistoryScreen from './components/history/HistoryScreen';
import { clearAuthToken, getAuthToken } from './utils/authStorage';

function AppWrapper() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = getAuthToken();

    if (!token || isTokenExpired(token)) {
      clearAuthToken();
      if (location.pathname !== '/login' && location.pathname !== '/reset-password') {
        const redirectTo = `${location.pathname}${location.search}${location.hash}`;
        navigate(`/login?redirect=${encodeURIComponent(redirectTo)}`, { replace: true });
      }
    }
  }, [navigate, location.pathname, location.search, location.hash]);

  function isTokenExpired(token) {
    try {
      const decoded = jwtDecode(token); // 👈 corrección acá
      const currentTime = Date.now() / 1000;
      return decoded.exp < currentTime;
    } catch (error) {
      return true;
    }
  }

  return (
    <Routes>
      <Route element={<Dashboard />}>
        <Route path="/inspections/:inspectionId/upload" element={<UploadImagesScreen />} />
        <Route path="/results" element={<ImageResults />} />
        <Route path="/inspections/:inspectionId/results" element={<ImageResults />} />
        <Route path="/projects" element={<ProyectsScreen />} />
        <Route path="/" element={<ModuleSelection />} />
        <Route path="/modules/electric-network" element={<DashboardHome />} />
        <Route
          path="/modules/emissions"
          element={(
            <ModulePlaceholder
              title="Emissions"
              subtitle="Methane campaigns, Sniffer4D imports, sensor overlays, annotations, and reporting will live here."
              icon={modulePlaceholderIcons.emissions}
              accent="#059669"
            />
          )}
        />
        <Route path="/modules/thermal-pipeline" element={<ThermalDashboard />} />
        <Route path="/reports" element={<ReportsScreen />} />
        <Route path="/projects/new" element={<NewProject />} />
        <Route path="/projects/:projectId" element={<ProjectDetails />} />
        <Route path="/projects/:projectId/history" element={<HistoryScreen />} />
        <Route path="/inspections/:inspectionId" element={<InspectionDetails />} />
        <Route path="/inspections/:inspectionId/selectImages" element={<SelectImages />} />
        <Route path="/profile" element={<ProfileScreen />} />
        <Route path="/users" element={<UsersScreen />} />
        <Route path="/notifications" element={<NotificationsScreen />} />
      </Route>

      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />

    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <AppWrapper />
      </UserProvider>
    </BrowserRouter>
  );
}
